export function OpenCircleIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2422_11059)">
        <circle cx="12" cy="12" r="11" fill="white" stroke="#607D8B" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id="clip0_2422_11059">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
